// extracted by mini-css-extract-plugin
module.exports = {"urunler":"Urunler-module--urunler--ym6z4"};